import React from 'react'
import AdvantageDisadvantageCard from '../organisms/AdvantageDisadvantageCard'

const M15AdvantagesDisadvantages = ({ advantageCards, anchorLinkId }) => {
  return (
    <section className="my-10 md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-i lg:px-10">
          <div className="flex justify-between pl-5 pb-8 mb-8 space-x-6 overflow-x-auto col-1-type-i sm:px-7 md:px-8 lg:px-0 lg:overflow-hidden -mx-6.5 lg:mx-0 no-scrollbars">
            <div className="w-[60vw] flex-shrink-0 lg:flex-1">
              <AdvantageDisadvantageCard {...advantageCards[0]} />
            </div>
            <div className="w-[60vw] flex-shrink-0 lg:flex-1 pr-5 lg:pr-0">
              <AdvantageDisadvantageCard {...advantageCards[1]} />
            </div>
          </div>
          <div className="flex justify-between pl-5 pb-8 mb-8 space-x-6 overflow-x-auto col-2-type-i sm:px-7 md:px-8 lg:px-0 lg:overflow-hidden -mx-6.5 lg:mx-0 no-scrollbars">
            <div className="w-[60vw] flex-shrink-0 lg:flex-1">
              <AdvantageDisadvantageCard {...advantageCards[2]} />
            </div>
            <div className="w-[60vw] flex-shrink-0 lg:flex-1 pr-5 lg:pr-0">
              <AdvantageDisadvantageCard {...advantageCards[3]} />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default M15AdvantagesDisadvantages
